import useInterval from 'use-interval'
import React, { useState, useEffect } from 'react'



const useCurrentTime = () => {
    const createDate = (newDate) => {
        let dateObj = {}
        dateObj.date = newDate.toDateString()
        dateObj.hours = newDate.getHours()
        dateObj.minutes = newDate.getMinutes()
        dateObj.seconds = newDate.getSeconds()
        return dateObj
    }
    const [date, setDate] = useState(createDate(new Date()))
    useInterval(() => {
        setDate(createDate(new Date()));
    }, 1000
    )

    return date
}

export default useCurrentTime